import { useEffect, useRef, useState } from 'react'

import { useUserData } from '../../../../../../../hooks'
import {
  getMockApplicantsComparison,
  postMockApplicantDecision,
} from '../../../../../../RentalPortalApplicant'
import {
  getIsRentalPortalPageReadCurrent,
  getRentalPortalPageReadKey,
} from '../../../../../RentalPortal.utils'
import {
  APPLICANT_DECISION_ACTION,
  getIsApplicantBlockConflictError,
} from '../../../../../RentalPortalApplicantProfile'
import { getApplicantComparisonItems } from '../../RentalPortalApplicantComparison.utils'

export function useApplicantComparison({ listingId }) {
  const currentUser = useUserData()

  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)
  const [conflictKey, setConflictKey] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [loadedReadKey, setLoadedReadKey] = useState(null)

  const readIdRef = useRef(0)

  const readKey = getRentalPortalPageReadKey([listingId, reloadKey])

  async function loadComparison() {
    readIdRef.current += 1

    const readId = readIdRef.current

    return getMockApplicantsComparison({ listing_id: listingId })
      .then(({ data }) => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setResponse(data)
          setError(false)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
      .catch(() => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setError(true)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      loadComparison()
    }
  }, [readKey])

  function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  async function submitSelect({ applicantId, note }) {
    setConflictKey(null)

    try {
      await postMockApplicantDecision({
        action: APPLICANT_DECISION_ACTION.select,
        applicantId,
        currentUser,
        note,
      })
    } catch (error) {
      if (!getIsApplicantBlockConflictError(error)) {
        throw error
      }

      setConflictKey('RentalPortal.ApplicantDecisionConflictKey')
    }

    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    conflictKey,
    handleRefresh,
    hasError,
    isInitiated,
    isLoading: loadedReadKey !== readKey,
    items: getApplicantComparisonItems(response),
    submitSelect,
  }
}
